export const SEGMENT_ANONYMOUS_ID_COOKIE = "segment_anonymous_id"
